import * as React from 'react';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { Radio } from 'antd';
import { RenewalSuggestionDto } from '../../types';
import RenewalSuggestionField from './RenewalSuggestionField';
import './RenewalSuggestionCard.less';

interface Props {
    suggestion: RenewalSuggestionDto;
    isSelected: boolean;
    onSuggestionSelect: (suggestion: RenewalSuggestionDto) => void;
}

const directBusinessTypes = ['DIRECT', 'NONPROPDIR'];

const RenewalSuggestionCard: React.FC<Props> = ({ suggestion, isSelected, onSuggestionSelect }: Props) => {
    const isDirectBusinessType = suggestion.typeOfBusinessCode
        ? directBusinessTypes.includes(suggestion.typeOfBusinessCode)
        : false;
    const partnerField = isDirectBusinessType
        ? { label: 'Insured', value: suggestion.insuredName }
        : { label: 'Cedent', value: suggestion.cedentName };

    const renderBusinessId = () => {
        if (!suggestion.businessId) {
            return null;
        }

        return <span className="business-id">{suggestion.businessId}</span>;
    };

    const renderStartDate = () => {
        if (!suggestion.startDate) {
            return null;
        }

        const parsedDate = DateTime.fromJSDate(new Date(suggestion.startDate));
        return <span className="start-date">{parsedDate.isValid ? parsedDate.toFormat('dd.MM.yyyy') : ''}</span>;
    };

    const getLimits = () => {
        const limits: string[] = [];

        if (suggestion.coverLimit) {
            limits.push(`Cover: ${suggestion.coverLimit}`);
        }

        if (suggestion.excessLimit) {
            limits.push(`Excess: ${suggestion.excessLimit}`);
        }

        if (suggestion.liabilityLimit) {
            limits.push(`Liability: ${suggestion.liabilityLimit}`);
        }

        return limits;
    };

    return (
        <div className={`renewal-suggestion-card-container ${isSelected ? 'selected' : ''}`}>
            <div className="radio-button-container">
                <Radio checked={isSelected} onClick={() => onSuggestionSelect(suggestion)} />
            </div>

            <div className="content-container">
                <div className="summary-container">
                    {renderBusinessId()}
                    {renderStartDate()}
                </div>

                <div className="field-columns-container">
                    <div className="field-column">
                        <RenewalSuggestionField fieldLabel={partnerField.label} fieldValue={partnerField.value} />
                        <RenewalSuggestionField fieldLabel="Broker" fieldValue={suggestion.brokerName} />
                    </div>

                    <div className="field-column">
                        <RenewalSuggestionField fieldLabel="Main Class" fieldValue={suggestion.mainClassesOfBusiness} />
                        <RenewalSuggestionField fieldLabel="Type" fieldValue={suggestion.typeOfParticipation} />
                    </div>

                    <div className="field-column">
                        <RenewalSuggestionField fieldLabel="Location" fieldValue={suggestion.locations} />
                        <RenewalSuggestionField
                            fieldLabel="Limits"
                            fieldValue={getLimits()}
                            fieldValuesDelimiter="; "
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(RenewalSuggestionCard);
